<template>
  <div>
    <a-form-model
      ref="ruleAuditForm"
      :rules="rules"
      :model="ruleAuditForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-card title="基础设置" :bordered="false" :headStyle="{fontSize:'18px'}">
        <a-form-model-item label="种子二分销售抽成" :required="true">
          <a-radio-group v-model="ruleAuditForm.connectionSeedSalesHasCommission">
            <a-radio :value="1">抽佣给一级运营商</a-radio>
            <a-radio :value="0">一级运营商不抽佣(即获得100%佣金)</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-card>
      <a-card title="佣金设置" :bordered="false" :headStyle="{fontSize:'18px'}">
        <a-form-model-item label="上级抽成下级分佣比例" prop="connectionCommissionRate">
          <a-input v-model="ruleAuditForm.connectionCommissionRate" style="width: 150px" placeholder="0~100"
                   suffix="%"></a-input>
        </a-form-model-item>
        <a-form-model-item label="设置方式" :required="true">
          按品类设置
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" v-for="(item,idy) in ruleAuditForm.detailDtoList"
                           :key="idy">
          <a-select placeholder="请选择品类" v-model="item.detailProCatalogId" style="width: 150px;margin-right: 20px">
            <a-select-option v-for="(i,idx) in menuList" :key="idx" :value="i.code">
              {{ i.name }}
            </a-select-option>
          </a-select>
          抽成下级比例
          <a-input v-model="item.detailCommissionRate" style="width: 150px" placeholder="0~100" suffix="%"></a-input>
          <a-button type="danger" style="margin-left: 20px" @click="delDtoList(item,idy)">
            移除
          </a-button>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <div class="addList" @click="addprocatalogList">+ 添加</div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="submitAuditForm" :loading="submitLoading">保存</a-button>
        </a-form-model-item>

      </a-card>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'SocialSetting',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 4 },
          xl: { span: 5 },
          lg: { span: 5 },
          sm: { span: 7 },
          md: { span: 10 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 17 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 16 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 14 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 14 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 11 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 11 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 4 },
          xl: { offset: 5 },
          lg: { offset: 5 },
          sm: { offset: 7 },
          md: { offset: 10 },
          xs: { offset: 12 }
        }
      },
      ruleAuditForm: {
        connectionSeedSalesHasCommission: 1,
        connectionCommissionRate: 0,
        detailDtoList: []
      },
      rules: {
        connectionCommissionRate: [
          { required: true, message: '请输入佣金比例', trigger: 'blur' },
          { pattern: /^(0|[1-9]\d?|100)$/, message: '请输入正确的比例', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      menuList: []

    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SocialSetting', title: '内容设置' },
      { name: 'SocialRule', title: '佣金规则' }
    ])
    this.getFunctionSettingDetails()
    let list = this.getAppConstants().getProductTypeList()
    this.menuList = [...list, ...[{
      name: '火车票',
      code: 7
    }]]
  },
  methods: {
    addprocatalogList() {
      let arr = {
        detailProCatalogId: undefined,
        detailCommissionRate: 0
      }
      if (this.ruleAuditForm.detailDtoList.length > 9) {
        this.$message.error('添加不能超过10条')
        return
      }
      this.ruleAuditForm.detailDtoList.push(arr)
      this.getLogUtils().logWithTag('detailDtoList', this.ruleAuditForm.detailDtoList)
    },
    delDtoList(item, idy) {
      this.ruleAuditForm.detailDtoList.splice(idy, 1)
    },
    //提交设置信息
    submitAuditForm() {
      let isNoChoose = false
      let isNotext = false
      let procatalogIdList = []
      this.getLogUtils().logWithTag('detailDtoList', this.ruleAuditForm.detailDtoList)
      this.ruleAuditForm.detailDtoList.forEach(v => {  //detailCommissionRate  detailProcatalogId
        if (v.detailProCatalogId) {
          procatalogIdList.push(v.detailProCatalogId)
        } else {
          isNoChoose = true
        }
        if (!/^(0|[1-9]\d?|100)$/.test(v.detailCommissionRate)) {
          isNotext = true
        }
      })
      if (isNoChoose) {
        return this.$message.error('请选择品类')
      }
      if (isNotext) {
        return this.$message.error('抽成比例数值为0~100')
      }
      if (new Set(procatalogIdList).size !== procatalogIdList.length) {
        return this.$message.error('选择品类有重复')
      }
      this.$refs.ruleAuditForm.validate(valid => {
        if (valid) {
          this.updateFunctionSetting()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //更新功能设置信息
    updateFunctionSetting() {
      this.submitLoading = true
      delete this.ruleAuditForm.connectDetailVoList
      this.getHttpServices().getUserService().post('merchant/connection/rule', this.ruleAuditForm).then(res => {
        this.$message.success('保存成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取功能设置信息
    getFunctionSettingDetails() {
      this.getHttpServices().getUserService().get('merchant/connection/detail').then(res => {
        this.ruleAuditForm = res
        this.$set(this.ruleAuditForm, 'detailDtoList', res.connectDetailVoList)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less" scoped>
.addList {
  width: 200px;
  line-height: 40px;
  border: 1px #ccc dashed;
  text-align: center;
  cursor: pointer;
}


.text-tips {
  height: 40px;
  line-height: 40px;
  color: red;
}

.grid-content {
  line-height: 40px;
}

.colorrmb {
  color: #ff6600;
}

.avatar {
  border-radius: 4px;
  width: 100px;
  height: 100px;
}
</style>
